<script lang="ts">
	import { Card, CircleWithArrow, CircleWithHypen } from "@hitit/new_ui/src";
	import { t } from "../../../stores";
	import { formatKrwNumber } from "../../utils";

	export let title = "";
	export let quantity = 0;
	export let amount = 0;
	export let comparePeriod = "";
	export let compareTargetAmount = 0;

	function compareTwoData(__this: number, last: number) {
		if (last === 0) {
			return NaN;
		}

		if (__this > last) {
			return (__this / last) * 100 - 100;
		} else if (__this < last) {
			__this = __this === 0 ? 1 : __this;
			return (1 - __this / last) * -100;
		} else {
			return 0;
		}
	}

	function correctTheRatio(ratio: number, overWord: string, belowWord: string) {
		const positiveNumberLimit = 1000;
		const negativeNumberLimit = -99.9;
		if (isNaN(ratio)) {
			return `-%`;
		}

		if (ratio >= 0) {
			const more = ratio > positiveNumberLimit;
			const suffix = more ? `% ${overWord}` : "%";
			return `${more ? 999.9 : ratio.toFixed(1)}${suffix}`;
		} else {
			const less = negativeNumberLimit > ratio;
			const suffix = less ? `% ${belowWord}` : "%";
			return `${less ? 99.9 : (ratio * -1).toFixed(1)}${suffix}`;
		}
	}

	$: fixedRatio = Number(compareTwoData(amount, compareTargetAmount));
	$: compareClass =
		fixedRatio === 0 || isNaN(fixedRatio)
			? "same"
			: fixedRatio > 0
			? "high"
			: "low";

</script>

<Card noPadding>
	<div class="container" t-id={'sales-income'}>
		<span class="title"> {title} </span>
		<p class="quantity">{quantity}{$t('global.count_2')}</p>
		<p class="amount">{formatKrwNumber(amount)}{$t('global.KRW')}</p>
		<div
			t-id={compareClass}
			class="compare"
			class:high={compareClass === 'high'}
			class:low={compareClass === 'low'}>
			<span class="icon">
				{#if compareClass === 'same'}
					<CircleWithHypen />
				{:else if compareClass === 'high'}
					<CircleWithArrow up circleFill={'#44e4ae'} />
				{:else}
					<CircleWithArrow circleFill={'#f66d6c'} />
				{/if}
			</span>
			{comparePeriod}
			<span class="ratio">
				{correctTheRatio(fixedRatio, $t('global.more'), $t('global.less'))}
			</span>
		</div>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		background-image: url("/img/icons/incomeImage.png");
		background-size: 70.3px 77.6px;
		background-position: bottom 12px right 10px;
		background-repeat: no-repeat;
		gap: 10px;
		padding: 10px;
		color: #46474b;
		.title {
			color: #6d6f76;
		}
		.quantity {
			font-size: 1.25rem;
			font-weight: 500;
			word-break: break-all;
		}
		.amount {
			font-size: 1.875rem;
			word-break: break-all;
			font-weight: 600;
		}

		.compare {
			display: flex;
			align-items: center;
			color: #6d6f76;
			.icon {
				width: 20px;
				height: 20px;
				margin-right: 6px;
			}
			.ratio {
				font-weight: 500;
				margin-left: 4px;
			}
			&.high {
				color: #10c181;
			}

			&.low {
				color: #e54848;
			}
		}
	}
	@include DesktopSize {
		.container {
			padding: 30px 20px;
			background-size: 80.6px 89px;
			background-position: bottom 30px right 30px;
			.title {
				font-size: 1.25rem;
			}
			.quantity {
				font-size: 1.5rem;
			}
			.amount {
				font-size: 2.1875rem;
			}

			.compare {
				.icon {
					width: 26px;
					height: 26px;
				}

				.ratio {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
